import { render, staticRenderFns } from "./settings-section-title.vue?vue&type=template&id=5021cb2e&scoped=true&"
import script from "./settings-section-title.vue?vue&type=script&lang=js&"
export * from "./settings-section-title.vue?vue&type=script&lang=js&"
import style0 from "./settings-section-title.vue?vue&type=style&index=0&id=5021cb2e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5021cb2e",
  null
  
)

export default component.exports